module.exports = __webpack_public_path__ + "static/media/clock.416a237a.svg";